module.exports = __webpack_public_path__ + "static/media/pro-manPhoto01.c5bb9e5f.jpg";